





















import { vxm } from '@/store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { MY_PROFILE_WIZARD_COMPONENT_MAPPER } from '@/models/configs/ProfileConstants';

@Component
export default class MissingMandatoryStepV2 extends Vue {
  @Prop({ default: '' }) selectedSection;
  get missedSteps() {
    return vxm.users.RequiredStepsInfo.requiredStepsMissing;
  }
  stepNameTextMapping(step) {
    const stepKey = MY_PROFILE_WIZARD_COMPONENT_MAPPER[step] || step;
    const textMapping = {
      'user-address': 'Address',
      'certification-questioner': 'Certification Questionnaire',
      'education-history': 'Education History',
      language: 'Language',
      'my-documents': 'My Documents',
      'professional-reference': 'Professional References',
      'profile-picture': 'Profile Picture',
      protected_information: 'Protected Information',
      resume: 'Resume',
      skills: 'Skills/Specialties',
      'source-type': 'Source',
      'user-preference': 'Job Preference',
      'were-you-referred': 'Were you referred?',
      'work-experience': 'Work Experience',
    };
    if (textMapping[stepKey]) return textMapping[stepKey];
    const wizardStep =
      vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === step,
      );
    return wizardStep ? wizardStep.displayName : step;
  }
}
